/* eslint-disable */
// @ts-nocheck
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type UndownloadedFolderReportFragment = { __typename?: 'FolderUndownloadedReportOutput', folderId: number, folderName: string, downloadUrl: string, status?: Types.GqlFolderReportStatus | null, createdAt?: string | null, extension?: string | null, size?: number | null };

export type GetAuthQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAuthQuery = { __typename?: 'Query', user: { __typename?: 'UserType', id: number, username: string, fullName?: string | null, isVerified: boolean, isAdmin: boolean, roles: Array<Types.GqlUserRole>, premiumSubscription?: { __typename?: 'PremiumSubscriptionType', id: number } | null, liteSubscriptions: Array<{ __typename?: 'LiteSubscriptionType', id: number }>, undownloadedFolderReports: Array<{ __typename?: 'FolderUndownloadedReportOutput', folderId: number, folderName: string, downloadUrl: string, status?: Types.GqlFolderReportStatus | null, createdAt?: string | null, extension?: string | null, size?: number | null }> }, app: { __typename?: 'AppType', isSwitchedUser: boolean } };

export type SendVerifyEmailMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SendVerifyEmailMutation = { __typename?: 'Mutation', sendVerifyEmail: boolean };

export type GetUndownloadedFolderReportsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUndownloadedFolderReportsQuery = { __typename?: 'Query', user: { __typename?: 'UserType', undownloadedFolderReports: Array<{ __typename?: 'FolderUndownloadedReportOutput', folderId: number, folderName: string, downloadUrl: string, status?: Types.GqlFolderReportStatus | null, createdAt?: string | null, extension?: string | null, size?: number | null }> } };

export const UndownloadedFolderReportFragmentDoc = gql`
    fragment UndownloadedFolderReport on FolderUndownloadedReportOutput {
  folderId
  folderName
  downloadUrl
  status
  createdAt
  extension
  size
}
    `;
export const GetAuthDocument = gql`
    query GetAuth {
  user {
    id
    username
    fullName
    isVerified
    isAdmin
    roles
    premiumSubscription {
      id
    }
    liteSubscriptions {
      id
    }
    undownloadedFolderReports {
      ...UndownloadedFolderReport
    }
  }
  app {
    isSwitchedUser
  }
}
    ${UndownloadedFolderReportFragmentDoc}`;

/**
 * __useGetAuthQuery__
 *
 * To run a query within a React component, call `useGetAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuthQuery, GetAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAuthQuery, GetAuthQueryVariables>(GetAuthDocument, options);
      }
export function useGetAuthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuthQuery, GetAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAuthQuery, GetAuthQueryVariables>(GetAuthDocument, options);
        }
// @ts-ignore
export function useGetAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAuthQuery, GetAuthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAuthQuery, GetAuthQueryVariables>;
export function useGetAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAuthQuery, GetAuthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAuthQuery | undefined, GetAuthQueryVariables>;
export function useGetAuthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAuthQuery, GetAuthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAuthQuery, GetAuthQueryVariables>(GetAuthDocument, options);
        }
export type GetAuthQueryHookResult = ReturnType<typeof useGetAuthQuery>;
export type GetAuthLazyQueryHookResult = ReturnType<typeof useGetAuthLazyQuery>;
export type GetAuthSuspenseQueryHookResult = ReturnType<typeof useGetAuthSuspenseQuery>;
export type GetAuthQueryResult = ApolloReactCommon.QueryResult<GetAuthQuery, GetAuthQueryVariables>;
export const SendVerifyEmailDocument = gql`
    mutation SendVerifyEmail {
  sendVerifyEmail
}
    `;
export type SendVerifyEmailMutationFn = ApolloReactCommon.MutationFunction<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>;

/**
 * __useSendVerifyEmailMutation__
 *
 * To run a mutation, you first call `useSendVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerifyEmailMutation, { data, loading, error }] = useSendVerifyEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendVerifyEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>(SendVerifyEmailDocument, options);
      }
export type SendVerifyEmailMutationHookResult = ReturnType<typeof useSendVerifyEmailMutation>;
export type SendVerifyEmailMutationResult = ApolloReactCommon.MutationResult<SendVerifyEmailMutation>;
export type SendVerifyEmailMutationOptions = ApolloReactCommon.BaseMutationOptions<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>;
export const GetUndownloadedFolderReportsDocument = gql`
    query GetUndownloadedFolderReports {
  user {
    undownloadedFolderReports {
      ...UndownloadedFolderReport
    }
  }
}
    ${UndownloadedFolderReportFragmentDoc}`;

/**
 * __useGetUndownloadedFolderReportsQuery__
 *
 * To run a query within a React component, call `useGetUndownloadedFolderReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUndownloadedFolderReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUndownloadedFolderReportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUndownloadedFolderReportsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>(GetUndownloadedFolderReportsDocument, options);
      }
export function useGetUndownloadedFolderReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>(GetUndownloadedFolderReportsDocument, options);
        }
// @ts-ignore
export function useGetUndownloadedFolderReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>;
export function useGetUndownloadedFolderReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUndownloadedFolderReportsQuery | undefined, GetUndownloadedFolderReportsQueryVariables>;
export function useGetUndownloadedFolderReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>(GetUndownloadedFolderReportsDocument, options);
        }
export type GetUndownloadedFolderReportsQueryHookResult = ReturnType<typeof useGetUndownloadedFolderReportsQuery>;
export type GetUndownloadedFolderReportsLazyQueryHookResult = ReturnType<typeof useGetUndownloadedFolderReportsLazyQuery>;
export type GetUndownloadedFolderReportsSuspenseQueryHookResult = ReturnType<typeof useGetUndownloadedFolderReportsSuspenseQuery>;
export type GetUndownloadedFolderReportsQueryResult = ApolloReactCommon.QueryResult<GetUndownloadedFolderReportsQuery, GetUndownloadedFolderReportsQueryVariables>;